import * as types from '@/store/types';

export default {
  async listCountries({ commit }) {
    try {
      const { data } = await axios.get(`/api/web/countries/list`);
      commit(types.LIST_COUNTRIES, { countries: data });
      return data;
    } catch (e) {
      return null;
    }
  },

  async countryCities({ commit }, country) {
    try {
      const { data } = await axios.get(`/api/web/countries/${country}/cities`);
      return data;
    } catch (e) {
      return [];
    }
  }
};
